// AI Upgraded Component
import { Component, OnInit, ChangeDetectionStrategy, Input, Inject } from '@angular/core';
import { ExtensionService } from '../../services/extension.service';
@Component({
    selector: 'extension-guide-dialog',
    templateUrl: './extension-guide-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ExtensionGuideDialogComponent implements OnInit {
    @Input() monDialogId!: string;
    currentExtension: any;

    constructor (
        @Inject(ExtensionService) private extensionService: ExtensionService,
    ) {}

    ngOnInit (): void {
        this.currentExtension = this.extensionService.getCurrentExtensionInfo();
    }
}
